'use strict';

angular
  .module('ClinicApp')
  .controller('ModalCSatSurveyCtrl', function(
    $scope,
    $modalInstance,
    $stateParams,
    OCWizardUtil,
    WizardHandler,
    clinic,
    SentimentService,
    CurrentUser,
  ) {
    $scope.clinic = clinic;

    $scope.currentStep = null;

    $scope.options = _.range(1, 11);

    var currentStep = parseInt($stateParams.step || 1, 2);
    OCWizardUtil.setStep($scope, currentStep);
    $scope.$watch(function() {
      return WizardHandler.wizard();
    });

    var userId = CurrentUser.getUserId();

    $scope.sentiment = {
      score: undefined,
      feedback: '',
      submittedForm: false,
      role: '',
      surveyType: 'Monthly CSAT',
      userId: userId,
    };

    $scope.setScore = function(score) {
      $scope.sentiment.score = score;
    };

    $scope.submitFeedbackForm = function($event) {
      $event.preventDefault();
      $scope.sentiment.submittedForm = true;
      SentimentService.createNewClinicSentiment(clinic.id, $scope.sentiment);
      $modalInstance.close();

    };

    $scope.close = function() {
      $scope.sentiment.submittedForm = true;
      SentimentService.createNewClinicSentiment(clinic.id, $scope.sentiment);
      $modalInstance.close();
    };

    $scope.finishWizard = function() {
      SentimentService.createNewClinicSentiment(clinic.id, $scope.sentiment);
      $modalInstance.close();
    };
  });
